
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrintQueueGroupsManager(
    GroupListService, $timeout, $http, $q, $filter, toastr,
    GroupListPOSTPaging, GroupFilterModel, $rootScope, Utils,
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        prepModifyGroups: '=modifyGroups',
        exclude: '=exclude',
        tenant: "=tenant",
        dialogMode: "=mode",
        closeDialog: '&closeDialog',
        selection: '&selection',
      },
      templateUrl: 'app/components/printQueueProperties/printQueueGroups/printQueueGroupsManager/printQueueGroupsManager.html',
      link: function(scope) {

        scope.modifyGroups = angular.copy(scope.prepModifyGroups) || [];
        scope.groupListPaging = new GroupListPOSTPaging();
        scope.groupList = [];
        scope.noGroupSelected = true;
        scope.ALLOW_UPDATE = false;
        scope.ALLOW_REMOVE = false;
        scope.ALLOW_MODIFY = false;
        var scrollEnd = null;
        var containerHeight = null;
        // var customKeyBinding = false;
        scope.step = 'SELECT';
        scope.updating = false;

        scope.steps = {
          SELECT: 'SELECT',
          MANAGE: 'MANAGE',
          UPDATE: 'UPDATE'
        }

        scope.inconsistencyDetected = false;
        // scope.DELETE_ALL_SELECTED = false;
        var pageSections = {};

        scope.groupSettingsModel = {
          exclusiveAccess: false,
          autoInstall: false,
          defaultForGroup: false,
        };

        scope.groupSettingsMiddleStage = {
          exclusiveAccess: false,
          autoInstall: false,
          defaultForGroup: false,
        };

        scope.groupRemoveModel = {
          accept: false
        };

        scope.UPDATING = false;
        scope.FAILED = false;

        scope.searchString = '';
        scope.search = {string: ''};
        scope.groupsLoaded = 0;
        scope.groupsTotal = 0;
        scope.selectedGroups = [];
        const excludedGrups = scope.exclude.map(group => group.info._links.self.href) || [];

        if (scope.dialogMode === 'ADD_GROUPS') {
          scope.groupListPaging.pagingCriteria.exclude = excludedGrups;
          $timeout(()=>{
            angular.element('.add-group-dialog').on('scroll', function (event) {
              scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
              containerHeight = event.currentTarget.scrollHeight;

              if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
                if (scrollEnd > containerHeight) {
                  $timeout(function() {
                    getNextGroupsPage();
                  }, 300)
                }
              }
            });
          },300)
        }

        if (scope.dialogMode === 'MODIFY_GROUPS') {
          checkConsistency()
        }


        (function() {
          // Maybe apply filters preset
          scope.presetFilters = [{
            name: 'Groups',
            parameter: 'inUse',
            key: 'inUse',
            type: 'radio',
            value: 'PrintixAssignedGroups',
            state: true
          }]

          scope.filtersList = new GroupFilterModel('PRINT_QUEUE_GROUPS').filters;
        })();

        scope.getFirstGroupsPage = function () {
          getFirstGroupsPage();
        }

        function excludeGroups () {
          scope.groupListPaging.pagingCriteria.exclude = [];
          scope.groupListPaging.pagingCriteria.exclude = excludedGrups;
          scope.groupListPaging.pagingCriteria.exclude = scope.groupListPaging.pagingCriteria.exclude.concat(scope.selectedGroups.map(group => group.info._links.self.href))
        }

        function getFirstGroupsPage() {
          excludeGroups();
          scope.groupListPaging.pagingCriteria.page = 0;
          scope.loadingPage = true;
          scope.groupList = [];
          pageSections = {};

          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response) {
            angular.element('.add-group-dialog').scrollTop(0);
            pageSections[response.page.number] = response
            scope.totalPages = response.page.totalPages;
            scope.groupList = response.list;
            scope.loadingPage = false;
            scope.groupsTotal = response.page.totalElements
            scope.groupsLoaded = scope.groupList.length;
          }).catch(function(error){})
        }

        scope.textSearch = function () {
          scope.groupListPaging.pagingCriteria.match = scope.search.string;
          angular.element('.add-group-dialog').scrollTop(0);
          getFirstGroupsPage();
        }


        function getNextGroupsPage () {
          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.groupListPaging.pagingCriteria.page += 1;
            GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response){
              pageSections[response.page.number] = response
              if (response.list) {
                scope.groupList = scope.groupList.concat(response.list);
              }
              scope.loadingPage = false;
              scope.groupsTotal = response.page.totalElements
              scope.groupsLoaded = scope.groupList.length;
            }).catch(function(error){});
          }
        }

        function getThisPageSection (pageSection) {
          var pageSectionsKeys = Object.keys(pageSections).length -1;
          excludeGroups();

          scope.groupListPaging.pagingCriteria.page = pageSection
          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function(response){

            if (pageSection < pageSectionsKeys) {
              pageSections[pageSection] = response
              getThisPageSection(pageSection += 1)
            } else {
              var pageSectionList = []
              pageSections[pageSection] = response

              for(var key in pageSections) {
                pageSectionList = pageSectionList.concat(pageSections[key].list)
              }

              scope.groupList = pageSectionList
              scope.loadingPage = false;
              scope.groupsTotal = response.page.totalElements
              scope.groupsLoaded = scope.groupList.length;
            }
          }).catch(function(error){});
        }




        scope.addLoadedGroups = function () {
          scope.loadingPage = true;


          scope.groupList.forEach((group) => {
            for (var key in scope.groupSettingsModel) {
              group[key] = scope.groupSettingsModel[key]
            }
          })

          scope.selectedGroups = scope.selectedGroups.concat(scope.groupList)
          scope.selectedGroups = scope.selectedGroups.slice().sort((a, b) => a.info.name.localeCompare(b.info.name));
          getFirstGroupsPage()
          validateForm()
        }

        scope.removeSelectedGroups = function () {
          scope.loadingPage = true;
          scope.selectedGroups = []
          getFirstGroupsPage()
          validateForm()
        }

        scope.addGroup = function (group, index) {
          scope.loadingPage = true;

          for (var key in scope.groupSettingsModel) {
            group[key] = scope.groupSettingsModel[key]
          }

          scope.selectedGroups.push(group);
          scope.selectedGroups = scope.selectedGroups.slice().sort((a, b) => a.info.name.localeCompare(b.info.name));

          getThisPageSection(getSectionFromItemIndex(index));
          validateForm()
        }

        function getSectionFromItemIndex(index) {
          return Math.floor(index / 20);
        }

        scope.removeGroup = function (group) {
          scope.loadingPage = true;
          scope.selectedGroups = scope.selectedGroups
            .filter(filteredGroup => filteredGroup !== group)
            .sort((a, b) => a.info.name.localeCompare(b.info.name));
          var index = findInsertionIndex(group.info.name);
          getThisPageSection(getSectionFromItemIndex(index));
          validateForm()
        }

        scope.removeModifyGroup = function (group) {
          scope.modifyGroups = scope.modifyGroups
            .filter(filteredGroup => filteredGroup !== group)
            .sort((a, b) => a.info.name.localeCompare(b.info.name));
            validateRemoveForm()
        }

        scope.removeModifyGroup_MODIFY = function (group) {
          scope.modifyGroups = scope.modifyGroups
            .filter(filteredGroup => filteredGroup !== group)
            .sort((a, b) => a.info.name.localeCompare(b.info.name));
            validateModifyForm()
        }

        function validateForm () {
          scope.ALLOW_UPDATE = scope.selectedGroups.length && Object.values(scope.groupSettingsModel).some(value => value === true)
        }

        function validateModifyForm () {
          scope.ALLOW_MODIFY = scope.modifyGroups.length && !scope.inconsistencyDetected && Object.values(scope.groupSettingsModel).some(value => value === true)
        }

        function validateRemoveForm () {
          if (scope.modifyGroups.length && scope.groupRemoveModel.accept) {
            scope.ALLOW_REMOVE = true;
          } else {
            scope.ALLOW_REMOVE = false;
          }
        }

        function findInsertionIndex(name) {
          let left = 0;
          let right = scope.groupList.length - 1;

          while (left <= right) {
            const middle = Math.floor((left + right) / 2);
            const middleItemName = scope.groupList[middle].info.name;

            if (middleItemName === name) {
              return middle;
            }

            if (name < middleItemName) {
              right = middle - 1;
            } else {
              left = middle + 1;
            }
          }

          return left;
        }

        scope.resetDialog = function () {
          scope.loadingPage = true;
          scope.selectedGroups = [];

          $timeout(()=> {
            // scope.selectedGroups = angular.copy(scope.exclude) || [];
            getFirstGroupsPage();
          }, 1100)
          validateForm()
        }

        scope.resetModel = function () {
          for (var key in scope.groupSettingsModel) {
            scope.groupSettingsModel[key] = false;
          }
          scope.selectedGroups.forEach((group) => {
            for (var key in scope.groupSettingsModel) {
              group[key] = scope.groupSettingsModel[key]
            }
          })
          validateForm()
        }



        scope.next = function (step) {
          scope.step = step
          switch (step) {
            case 'SELECT':

            break;
            case 'MANAGE':
              scope.groupSettingsModel = {
                exclusiveAccess: false,
                autoInstall: false,
                defaultForGroup: false,
              };

              scope.groupSettingsMiddleStage = {
                exclusiveAccess: false,
                autoInstall: false,
                defaultForGroup: false,
              };
              checkConsistency();
            break;
            case 'UPDATE':
              throttledUpdater();
            break;
            case 'ADD_GROUPS':
              throttledUpdater('selectedGroups');
            break;
            case 'REMOVE_GROUPS':
              throttledUpdater('modifyGroups');
            break;
            case 'MODIFY_GROUPS':
              throttledUpdater('modifyGroups');
            break;
            case 'CLOSE':
              scope.closeDialog({state: 'EXIT'});
            break;
          }
        }

        function checkConsistency () {
          const attributeKeys = ['exclusiveAccess', 'autoInstall', 'defaultForGroup'];
          const attributeStatus = attributeKeys.reduce((acc, key) => {
              const attributeValues = scope.modifyGroups.map(item => item[key]);
              const hasTrue = attributeValues.some(value => value === true);
              const hasFalse = attributeValues.some(value => value === false);
              acc[key] = hasTrue && !hasFalse ? true : (!hasTrue && hasFalse ? false : 'mixed');
              return acc;
          }, {});

          for (var key in attributeStatus) {
            if (attributeStatus[key] === 'mixed') {
              scope.groupSettingsMiddleStage[key] = true
            } else {
              scope.groupSettingsMiddleStage[key] = false
              scope.groupSettingsModel[key] = attributeStatus[key]
            }
          }

          scope.inconsistencyDetected =  Object.values(attributeStatus).some(attribute => attribute === "mixed")
          // scope.DELETE_ALL_SELECTED = Object.values(attributeStatus).every(value => value === false);
          return attributeStatus;
        }

        scope.updateModel = function (attribute) {
          scope.selectedGroups.forEach(group => {group[attribute] = scope.groupSettingsModel[attribute]})
          validateForm()
        }

        scope.updateModifyModel = function (attribute) {
          scope.modifyGroups.forEach(group => {group[attribute] = scope.groupSettingsModel[attribute]})
          checkConsistency();
          validateModifyForm()
        }

        scope.toggleRemove = function () {
          validateRemoveForm()
        }

        function CREATE_HTTP_MODEL (selectionReference) {

          var httpModel = {}
          for (var key in scope.groupSettingsModel) {
            httpModel[key] = {
              endpoint: setEndpoint(key),
              action: scope.groupSettingsModel[key] ? 'ADD' : 'REMOVE',
              state: '',
              groups: scope[selectionReference].filter(selectedGroup => {
                if (scope.exclude.some(excludedGroup => excludedGroup.id === selectedGroup.id && excludedGroup[key])) {
                  if (scope.groupSettingsModel[key]) {
                    return false;
                  } else {
                    return true;
                  }
                }
                return true;
              }).map(filteredGroup => filteredGroup.info._links.self.href)
            }
          }


          function setEndpoint (key) {
            var endpoint = ''
            switch (key) {
              case 'exclusiveAccess':
                endpoint = scope.context.printQueue.info._links['px:groups'].href
                break
              case 'autoInstall':
                endpoint = scope.context.printQueue.info._links['px:autoInstallGroups'].href
                break
              case 'defaultForGroup':
                endpoint = scope.context.printQueue.info._links['px:defaultForGroups'].href;
                break
            }
            return endpoint;
          }
          return httpModel
        }


        function throttledUpdater(actionReference) {
          const httpModel = scope.httpModel = CREATE_HTTP_MODEL(actionReference)
          scope.UPDATING = true;
          scope.FAILED = false;
          HTTP_SEQUENCE(httpModel).then(function(response) {
            scope.UPDATING = false;
            callback('success')
          }).catch(function(error) {
            scope.UPDATING = false;
            scope.FAILED = true;
            callback('error')
          });
          scope.closeDialog({state:'UPDATING'});
        }

        function HTTP_SEQUENCE (httpModel) {
          var report = {}
          var deferred = $q.defer()
          httpModel.exclusiveAccess.state = 'WorkingOnIt';
          update(httpModel.exclusiveAccess)
            .then(function(response) {
              report['STEP_1'] = response;
              $rootScope.$broadcast('PRINT_QUEUE_GROUPS_UPDATE', report)
              httpModel.exclusiveAccess.state = 'Done';
              httpModel.autoInstall.state = 'WorkingOnIt';
              return update(httpModel.autoInstall);
            }).catch(function(error) {})
            .then(function(response) {
              report['STEP_2'] = response;
              $rootScope.$broadcast('PRINT_QUEUE_GROUPS_UPDATE', report)
              httpModel.autoInstall.state = 'Done';
              httpModel.defaultForGroup.state = 'WorkingOnIt';
              return update(httpModel.defaultForGroup);
            }).catch(function(error) {})
            .then(function(response) {
              report['STEP_3'] = response;
              $rootScope.$broadcast('PRINT_QUEUE_GROUPS_UPDATE', report)
              httpModel.defaultForGroup.state = 'Done';
              return report;
            }).catch(function(error) {})
            .then(function(response) {
              report['FINAL'] = response;
              $rootScope.$broadcast('PRINT_QUEUE_GROUPS_UPDATE', report)
              deferred.resolve(report);
            })
            .catch(function(error) {
              report['ERROR'] = error;
              deferred.reject(report);
            });
          return deferred.promise;
        }


        function update (httpModel) {
          var deferred = $q.defer()
          if (httpModel.action === 'ADD') {
            POST(httpModel.endpoint, httpModel.groups).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error)
            });
          } else {
            DELETE(httpModel.endpoint, httpModel.groups).then(function(response) {
              deferred.resolve(response)
            }).catch(function(error) {
              deferred.reject(error)
            });
          }
          return deferred.promise;
        }

        function POST (endpoint, groups) {
          var deferred = $q.defer()
          scope.context.printQueue.groups_ADD(endpoint, groups).then(function(response) {
            deferred.resolve(response)
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise
        }

        function DELETE (endpoint, groups, index) {
          var deferred = $q.defer()
          scope.context.printQueue.groups_REMOVE(endpoint, groups).then(function(response) {
            deferred.resolve(response)
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise
        }

        function callback (type) {
          $timeout(() => {
            if (type === 'success') {
              toastr.success($filter('translate')('ChangesSaved'))
            }

            $rootScope.$broadcast('PRINT_QUEUE_GROUPS_UPDATE_CALLBACK')
          }, 800)

        }

        scope.close = function () {
          scope.closeDialog({state: 'EXIT'});
        }

        scope.$on('$destroy', function() {
          angular.element('.add-group-dialog').off('scroll');
          // customKeyBinding = false;
        });



      }
    };
  }

  pxPrintQueueGroupsManager.$inject = [
    'GroupListService', '$timeout', '$http', '$q', '$filter', 'toastr',
    'GroupListPOSTPaging', 'GroupFilterModel', '$rootScope', 'Utils'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintQueueGroupsManager', pxPrintQueueGroupsManager);

})();

